import { useParams } from 'react-router';
import { BackButton } from '~/commonComponents';
import history from '~/history';
import { Tab, TabList, TabPanel, Tabs } from '../../../commonComponents/Tabs';
import { Colors } from '../../../themes/colors';
import { OpenTab } from './components/OpenTab/OpenTab';
import { PendingTab } from './components/PendingTab/PendingTab';
import { ScheduledTab } from './components/ScheduledTab/ScheduledTab';
import { useShiftList } from './hooks/useShiftList';

export const ShiftList = () => {
  const params = useParams();
  const type = history.location.state ? history.location.state.type : params.type;
  const { activeTab, dashboardInfo, onChangeTab } = useShiftList({ type });

  return (
    <>
      <div className="component_container">
        <div
          className="floating_container"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            paddingBottom: 0,
          }}
        >
          <div
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <div style={{ position: 'absolute', left: 20, top: 40 }}>
              <BackButton />
            </div>

            <div>
              <span
                style={{
                  fontFamily: 'Nunito',
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  marginTop: 120,
                  marginBottom: 50,
                  color: Colors.neutral_600,
                  fontSize: 32,
                  fontWeight: 700,
                }}
              >
                Shifts Overview
              </span>
            </div>

            <div style={{ width: '85%', alignSelf: 'center', marginBottom: 80 }}>
              <Tabs initialTab={activeTab} onChangeTab={onChangeTab}>
                <TabList>
                  <Tab title="Open Shifts" dataCy="open-shifts-tab" />
                  <Tab
                    title="Action Needed"
                    badge={dashboardInfo?.pendingCount > 10 ? '10+' : dashboardInfo?.pendingCount}
                    dataCy="action-needed-tab"
                  />
                  <Tab title="Scheduled Shifts" dataCy="scheduled-shifts-tab" />
                </TabList>
                <TabPanel>
                  <OpenTab />
                  <PendingTab />
                  <ScheduledTab />
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
